import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { getLinks } from '../../services/linkService';
import {
  linksPageState,
  linksState,
  loadingLinksState,
  searchLinkState,
  selectedLinkIdState,
} from '../../storage/links';
import { Link } from '../../types/link';
import { PaginatedProvider } from './PaginatedProvider';

export function LinksProvider() {
  const setPaginatedLinks = useSetRecoilState(linksState);
  const setLoadingLinks = useSetRecoilState(loadingLinksState);
  const resetSelectedLinkId = useResetRecoilState(selectedLinkIdState);

  return (
    <PaginatedProvider<Link>
      searchState={searchLinkState}
      pageState={linksPageState}
      getPaginated={getLinks}
      setPaginated={setPaginatedLinks}
      onSearchChange={resetSelectedLinkId}
      onUpdateFinish={() => {}}
      setLoading={setLoadingLinks}
      update={undefined}
    />
  );
}
